const TIPS = {
  'simulation[_condition][bank_coupon_code]': 'Exclusivo para: Santander',
  'simulation[_condition][grace_period_days]': 'Exclusivo para: Pan',
};

export default TIPS;
